import datadogRum from '../../../utility/datadog-util';
export const dokbotTrackError = (surveyType) => {
    const error = new Error(`Dokbot does not available. SurveyType: ${surveyType}`);
    datadogRum.addError(error);
};
export const parseWorkflowId = (id) => {
    const result = {
        workflowId: id,
        orgSlug: null,
        orgId: null,
        useWIP: false,
    };
    if (!id.startsWith('@')) {
        return result;
    }
    const [orgName, slug, orgId, useWIP] = id.split('/');
    result.workflowId = slug;
    result.orgSlug = orgName.slice(Math.max(0, 1));
    result.orgId = orgId ? Number(orgId) : null;
    result.useWIP = Boolean(useWIP);
    return result;
};
